export const getCurrencySymbol = (currency: string) => {
    switch (currency) {
        case 'gbp':
            return 'GBP £';
        case 'usd':
            return 'USD $';
        case 'nzd':
            return 'NZD $';
        case 'cad':
            return 'CAD $';
        case 'aud':
            return 'AUD $';
        case 'eur':
            return 'EUR €';
        default:
            return 'USD $';
    }
}